/* Fifty Five – Journal-Artikel: Leseindikator + Sticky-Pille (kein Vanilla-Pendant).
   Leseindikator: schmale Linie unter dem Header, Fuellung = gelesener Anteil des Artikeltexts.
   Pille: sichtbar nach etwas Scrollen, ausgeblendet solange die Empfehlungskarte im Bild ist
   und sobald das Artikelende (Weiterlesen) erreicht ist. Ohne JS: kein Indikator, keine Pille. */
(function () {
  'use strict';
  var body = document.querySelector('[data-ffa-body]');
  var bar = document.querySelector('[data-ffa-progress] > span');
  var pill = document.querySelector('[data-ffa-pill]');
  var card = pill ? pill.querySelector('.product-sticky-form__card') : null;
  var reco = document.querySelector('[data-ffa-reco]');
  var end = document.querySelector('[data-ffa-end]');
  if (!body) return;

  var recoVisible = false;
  var endVisible = false;
  var pillShown = false;

  function setPill(show) {
    if (!card || show === pillShown) return;
    pillShown = show;
    card.classList.toggle('opacity-0', !show);
    card.classList.toggle('invisible', !show);
  }

  var ticking = false;
  /* FF 2026-09-18 (Design-Review Befund 12): Die Pille lag dauerhaft ueber dem
     Fliesstext und nahm rund 11 % der Viewport-Hoehe. Auf einer Leseseite
     konkurriert das mit dem Zweck der Seite. Jetzt richtungsabhaengig: beim
     Lesen (abwaerts) verschwindet sie, beim Zurueckscrollen ist sie sofort da -
     dasselbe Muster wie die Ankuendigungsleiste im Header ("Beim Hochscrollen").
     Der Schwellwert von 6 px verhindert Flackern bei Mikro-Bewegungen. */
  var lastY = window.scrollY;
  var scrollingUp = true;
  function update() {
    ticking = false;
    var rect = body.getBoundingClientRect();
    var top = rect.top + window.scrollY;
    var total = rect.height - window.innerHeight;
    var p = total > 0 ? (window.scrollY - top) / total : 1;
    p = Math.max(0, Math.min(1, p));
    if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    var y = window.scrollY;
    if (Math.abs(y - lastY) > 6) {
      scrollingUp = y < lastY;
      lastY = y;
    }
    setPill(y > 240 && scrollingUp && !recoVisible && !endVisible);
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  if ('IntersectionObserver' in window) {
    if (reco) new IntersectionObserver(function (e) { recoVisible = e[0].isIntersecting; onScroll(); }, { rootMargin: '0px 0px -10% 0px' }).observe(reco);
    if (end) new IntersectionObserver(function (e) { endVisible = e[0].isIntersecting; onScroll(); }).observe(end);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();

/* FF 2026-10-01: Journal-Tabellen auf dem Handy als Karten statt Querscrollen (Georg).
   Liest die Spaltenkoepfe aus thead und schreibt sie als data-label an jede Zelle; das Stapeln selbst
   macht ff-article.css unter 768 px. Nur Tabellen mit Kopfzeile und mindestens drei Spalten,
   zweispaltige passen ohnehin auf den Bildschirm. Ohne JS bleibt die scrollbare Tabelle. */
(function () {
  'use strict';
  var body = document.querySelector('[data-ffa-body]');
  if (!body) return;
  body.querySelectorAll('.ff-table-scroll > table').forEach(function (table) {
    var head = table.tHead && table.tHead.rows[0];
    if (!head) return;
    var labels = [];
    Array.prototype.forEach.call(head.cells, function (c) {
      var span = c.colSpan || 1;
      for (var i = 0; i < span; i++) labels.push(c.textContent.trim());
    });
    if (labels.length < 3) return;
    Array.prototype.forEach.call(table.querySelectorAll('tbody tr, tfoot tr'), function (row) {
      var col = 0;
      Array.prototype.forEach.call(row.cells, function (cell) {
        var span = cell.colSpan || 1;
        if (span >= labels.length) { row.classList.add('ff-table-group'); }
        else if (labels[col]) {
          cell.setAttribute('data-label', labels[col]);
          /* Inhalt in ein Element fassen, damit Text und Links im Flex-Layout nicht zerfallen;
             lange Zellen stehen unter statt neben ihrem Spaltenkopf. */
          if (col > 0) {
            cell.innerHTML = '<span class="ff-cell-v">' + cell.innerHTML + '</span>';
            if (cell.textContent.trim().length > 40) cell.classList.add('ff-cell--long');
          }
        }
        col += span;
      });
    });
    table.parentNode.classList.add('ff-table--stack');
  });
})();
